<ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<form
    [formGroup]="filterFormGroup"
    #filterForm="ngForm"
    id="filterForm"
>
    <p-toolbar>
        <div>
            <p-floatLabel variant="on">
                <p-select
                    *ngIf="UserTypeSelectItems as items; else loading"
                    [options]="items | orderBy: 'label'"
                    [filter]="true"
                    appendTo="body"
                    formControlName="userType"
                    styleClass="w-12rem"
                ></p-select>
                <label for="float-dd">Employee Type</label>
            </p-floatLabel>
        </div>
        <div>
            <p-floatLabel variant="on">
                <p-multiSelect
                    [virtualScroll]="true"
                    [itemSize]="dropdownItemHeight"
                    *ngIf="employees; else loading"
                    [options]="filteredEmployeeSelectItems | orderBy: 'label'"
                    [filter]="true"
                    appendTo="body"
                    maxSelectedLabels="1"
                    selectedItemsLabel="{0} item(s) selected."
                    formControlName="employee"
                    [panelStyle]="{ width: '12rem' }"
                ></p-multiSelect>
                <label for="float-dd">Employee</label>
            </p-floatLabel>
        </div>
        <div>
            <p-floatLabel variant="on">
                <p-multiSelect
                    [virtualScroll]="true"
                    [itemSize]="dropdownItemHeight"
                    *ngIf="filteredPayrollItemTypes as items; else loading"
                    [options]="items | orderBy: 'label'"
                    [filter]="true"
                    appendTo="body"
                    maxSelectedLabels="1"
                    selectedItemsLabel="{0} item(s) selected."
                    formControlName="payrollItemType"
                    [panelStyle]="{ width: '12rem' }"
                    (onChange)="FilterPayrollItemType.next($event.value)"
                ></p-multiSelect>
                <label for="float-dd">Payroll Item Type</label>
            </p-floatLabel>
        </div>
        <div>
            <p-floatLabel variant="on">
                <p-multiSelect
                    [virtualScroll]="true"
                    [itemSize]="dropdownItemHeight"
                    *ngIf="payrollItems as items; else loading"
                    [options]="items | orderBy: 'label'"
                    [filter]="true"
                    appendTo="body"
                    maxSelectedLabels="1"
                    selectedItemsLabel="{0} item(s) selected."
                    formControlName="payrollItem"
                    [panelStyle]="{ width: '12rem' }"
                ></p-multiSelect>
                <label for="float-dd">Payroll Item</label>
            </p-floatLabel>
        </div>
        <div>
            <button pButton type="button" (click)="onFillGrid()">Add</button>
        </div>
        <div>
            <button pButton type="button" (click)="Reset()">Clear filter</button>
        </div>       
    </p-toolbar>
</form>
